<template>
  <div class="col-md-12 mx-auto">
    <v-img aspect-ratio="1"
           :src="value" width="1000"/>
  </div>
</template>

<script>
export default {
  name: "imageShow",
  props: {
    value: ''
  },
  watch: {
    value(val) {
      this.$emit('input', val);
    }
  }
}
</script>

<style scoped>

</style>